export default __webpack_public_path__ + "77271d6ed88726ad36c6c55bc117ba4a.gif";